let Plugin_Athena = {

    init: function () {
        $(document)
            .on('modal.button.miniform.close.post', function (e, data) {
                // uložení a odeslání athena
                if (data.hasOwnProperty('miniformId') && 17 === parseInt(data['miniformId'])) {
                    e.preventDefault();
                    let buttonSave = $(':button[name="saveContinue"]');
                    if (buttonSave.length) {
                        $(document).off('ajaxStop');
                        buttonSave.trigger('click');
                    }
                }
            });
    }
};

$(document)
    .ready(function () {
        Plugin_Athena.init();
    });
